module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "copyright-information"
    }
  }, [_c('p', {
    staticStyle: {
      "padding-top": "150px"
    }
  }, [_c('strong', [_vm._v("To grow up decent, our children need new clothing to present themself in school in proper neat! The sun has to shine for our children too. Amen")])]), _c('br'), _vm._v(" "), _c('p', [_vm._v("Sign painted by welfare mothers demonstrating outside Board of Education headquarters in Brooklyn, 8/28/1969")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bdde7154","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0001.vue
// module id = 69
// module chunks = 0